import React from "react";
import { DropdownLink } from "components/layout/nav/dropdownLink";
import { NavLink } from "components/layout/nav/navLink";
import "./DesktopNav.scss";

function DesktopNav() {
  return (
    <div className="desktopNav">
      <NavLink label="Home" to="/" />
      <NavLink label="Register" to="/register" />
      <DropdownLink
        label="About"
        links={[
          { label: "Purpose", to: "/about/purpose" },
          { label: "Trustees", to: "/about/trustees" },
          { label: "Guidelines", to: "/about/guidelines" },
        ]}
      />
      <NavLink label="History" to="/history" />
      <NavLink label="Store" to="/store" />
      <NavLink label="Gallery" to="/gallery" />
      <DropdownLink
        label="PBH"
        links={[
          { label: "About", to: "/pbh/about" },
          { label: "Search", to: "/pbh/search" },
        ]}
        style={{ minWidth: "130px" }}
      />
      <NavLink label="Donate" to="/donate" />
      <NavLink label="Contact" to="/contact" />
    </div>
  );
}

export default DesktopNav;
